import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 4C3.55228 4 4 4.44772 4 5V19C4 19.5523 3.55228 20 3 20C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44772 4 3 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 4C9.55228 4 10 4.44772 10 5V19C10 19.5523 9.55228 20 9 20C8.44772 20 8 19.5523 8 19V5C8 4.44772 8.44772 4 9 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15 4C15.5523 4 16 4.44772 16 5V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19V5C14 4.44772 14.4477 4 15 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21 4C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20C20.4477 20 20 19.5523 20 19V5C20 4.44772 20.4477 4 21 4Z",
			fill: "currentColor"
		})
	]
});
export default SvgList;
